import {
  FormStepperData,
  IFormStepperData
} from '@/data/merchant-register-forms/FormStepperData'
import { HorizontalStep, HorizontalStepper } from '@dgshahr/ui-kit'

interface IProps {
  currentStep: IFormStepperData
}
function FormStepper({ currentStep }: IProps) {
  return (
    <HorizontalStepper
      activeStep={currentStep.id}
      size="medium"
      stepOrientation="horizontal"
      classname="pe-6 ps-4 ss02"
    >
      {FormStepperData.map((item) => (
        <HorizontalStep
          key={item.id}
          activeIcon={item.completeIcon}
          completeIcon={item.completeIcon}
          icon={item.icon}
          subTitle={item.subTitle}
          title={item.title}
        />
      ))}
    </HorizontalStepper>
  )
}

export default FormStepper
